export namespace NLegalEntities {
  export type ModelLegalEntity = {
    Id: number;
    Name: string | null;
    Description: string | null;
    Kpp: number | null;
    TaxPayerId: number | null;
    IsDeleted: boolean;
    CountConstantsPayments: number;
  };

  export type AddLegalEntityFormProps = {
    Name: string | undefined;
    TaxPayerId: string | undefined;
    Kpp: string | undefined;
    Description: string | undefined;
  };

  export type ModelItemEx = {
    Id: number;
    Name: string | null;
    IsDeleted: boolean;
  };
}
